import script from "./PageContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PageContainer.vue?vue&type=script&setup=true&lang=js"

import "./PageContainer.vue?vue&type=style&index=0&id=9ff4f4e0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ff4f4e0"]])

export default __exports__